import './Teacher.css';
import React, {useState} from "react";
import LoadingSpinner from "../../../shared/components/LoadingSpinner/LoadingSpinner";

const Teacher = React.memo(({ teacher, index }) => {

  const [imageIsLoaded, setImageIsLoaded] = useState(false);

  const handleImageIsLoaded = () => {
    setImageIsLoaded(true);
  }

  let imageAlignment = '';

  switch (index) {
    case 3:
      // Samantha Muñoz
      imageAlignment = '-47px';
      break;
    case 4:
      // Tamara Phillips
      imageAlignment = '27px';
      break;
    case 5:
      // Blaire Santos
      imageAlignment = '10px';
      break;
    case 6:
      // Jasibi Urbina
      imageAlignment = '20px';
      break;
    case 7:
      // Not in use
      imageAlignment = '37px';
      break;
    case 8:
      // Not in use
      imageAlignment = '53px';
      break;
    default:
      imageAlignment = '';
  }


  return (
    <div className='individualTeacher' style={{display: "flex", justifyContent: "center", marginBottom: "3rem"}}>
      <img src={teacher.image} alt={teacher.teacherName} className='teacherImage' style={{width: "33%"}} onLoad={handleImageIsLoaded} />
      {imageIsLoaded ? <>
        <div className='teacherDetail' style={{marginRight: imageAlignment}}>
          <h3 className='teacherName'>{teacher.teacherName}</h3>
          <div className='teacherEmail'>
            <p>Email: <span style={{color: '#02004e', fontWeight: "bold"}}>{teacher.email} </span> </p>
          </div>
        </div>
        </> : <LoadingSpinner />
      }
    </div>
  )
});

export default Teacher;
